/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint no-param-reassign:  [2, { "props": false }] */
import React, { useEffect, useState } from "react";
import styles from "./CustomProductOption.module.css";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";
import brandRefreshStyles from "./CustomProductOptionBrandRefresh.module.css";
import BrandRefreshQuantityControl from "./BrandRefreshQuantityControl";
import BrandRefreshBadges from "./BrandRefreshBadges";
import BrandRefreshDescriptionModal from "./BrandRefreshDescriptionModal";
import BrandRefreshTooltip from "./BrandRefreshTooltip";

const addIcon = require("./imgs/plus.svg");
const minusIcon = require("./imgs/minus.svg");
const darkAddIcon = require("./imgs/dark-plus.svg");
const darkMinusIcon = require("./imgs/dark-minus.svg");
const infoIcon = require("./imgs/info-icon.svg");

const renderBrandRefreshPrice = (price, currency) => {
  if (!price || !(price > 0) || !currency) return null;
  return (
    <span className={brandRefreshStyles.priceModifier} data-part="price-modifier">
      (+
      {currency.symbol}
      {price.toFixed(2)}
)
    </span>
  );
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }
    const mq = window.matchMedia("(max-width: 767px)");
    const handler = e => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    if (mq.addEventListener) {
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    }
    if (mq.addListener) {
      mq.addListener(handler);
      return () => mq.removeListener(handler);
    }
    return undefined;
  }, []);
  return isMobile;
};

function renderLegacyQuantityOption(props) {
  const {
    image,
    name,
    quantity,
    onChangeAdd,
    onChangeRemove,
    calories,
    renderPrice,
    price,
    currency,
    description,
    oos,
    addDisabled = false,
  } = props;
  const isAddDisabled = oos === 1 || addDisabled;
  let paddingClass = null;
  if (name.length < 14) {
    paddingClass = styles.bottomMargin45;
  } else if (name.length > 18) {
    paddingClass = [styles.topMargin0, styles.bottomMargin15].join(" ");
  }
  return (
    <div className={`${oos === 1 ? styles.oos : ''} flex md:flex-col md:items-center w-[343px] md:w-[216px] gap-2`}>
      <div className="w-[156px] h-[156px] md:w-[216px] md:h-[216px]">
        <img
          alt=""
          src={image}
          onError={i => {
            i.target.style.display = "none";
            return null;
          }}
          className="w-full object-contain"
        />
      </div>

      <div className="flex flex-col md:items-center md:text-center gap-2 w-[179px]">
        <h3 className={`${paddingClass} md:min-h-[46px] font-montserratBold text-lg leading-[22px] tracking-[-0.1px] text-dark dark:text-white`}>
          {name}
          <span className={styles.caloriesQuantity}>{calories}</span>
        </h3>
        <p className="text-darkElevationPrimary dark:text-[#B4A5BB] text-xs leading-[14px] md:min-h-[42px]">
          {description}
        </p>
        <div>
          <div className="w-[123px] flex flex-col items-center justify-center">
            {quantity ? (
              <div className="flex gap-3 items-center">
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      onChangeRemove();
                    }
                  }}
                  onClick={onChangeRemove}
                  className="w-11 h-11 rounded-full flex items-center dark:bg-dark bg-light border-[1px] border-dark dark:border-white"
                >
                  <img alt="" src={darkMinusIcon} className="block dark:hidden m-auto cursor-pointer" />
                  <img alt="" src={minusIcon} className="hidden dark:block m-auto cursor-pointer" />
                </div>
                <span className="text-dark dark:text-white font-montserratBold text-lg leading-[22px] tracking-[-0.1px]">
                  {quantity}
                </span>
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !isAddDisabled) {
                      onChangeAdd();
                    }
                  }}
                  onClick={!isAddDisabled ? onChangeAdd : () => {}}
                  className={`${ !isAddDisabled ? 'border-[1px] border-dark' : '' } w-11 h-11 rounded-full flex items-center dark:bg-dark bg-light dark:border-white`}
                >
                  <img alt="" src={darkAddIcon} className="block dark:hidden m-auto cursor-pointer" />
                  <img alt="" src={addIcon} className="hidden dark:block m-auto cursor-pointer" />
                </div>
              </div>
            ) : (
              <div className="flex gap-3 items-center">
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      onChangeRemove();
                    }
                  }}
                  onClick={onChangeRemove}
                  className="w-11 h-11 rounded-full flex items-center dark:bg-darkElevationPrimary bg-[#E6DFE8]"
                >
                  <img alt="" src={darkMinusIcon} className="block dark:hidden m-auto cursor-pointer" />
                  <img alt="" src={minusIcon} className="hidden dark:block m-auto cursor-pointer" />
                </div>
                <span className="text-dark dark:text-white font-montserratBold text-lg leading-[22px] tracking-[-0.1px]">
                  0
                </span>
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !isAddDisabled) {
                      onChangeAdd();
                    }
                  }}
                  onClick={!isAddDisabled ? onChangeAdd : () => {}}
                  className={`${ !isAddDisabled ? 'border-[1px] border-dark' : '' } w-11 h-11 rounded-full flex items-center dark:bg-dark bg-light dark:border-white`}
                >
                  <img alt="" src={darkAddIcon} className="block dark:hidden m-auto cursor-pointer" />
                  <img alt="" src={addIcon} className="hidden dark:block m-auto cursor-pointer" />
                </div>
              </div>
            )}
            <p className="py-1">{renderPrice(price, currency)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function renderBrandRefreshQuantityOption(props, hookState) {
  const {
    image,
    name,
    quantity,
    onChangeAdd,
    onChangeRemove,
    calories,
    price,
    currency,
    description,
    oos,
    metaTags = [],
    addDisabled = false,
  } = props;

  const { showDescription, setShowDescription, isMobile, showTooltip, setShowTooltip } = hookState;
  const toggleDescription = () => setShowDescription(prev => !prev);

  return (
    <>
      <div
        className={`${brandRefreshStyles.productCard} ${oos === 1 ? brandRefreshStyles.oosOverlay : ""}`}
        data-part="product-card"
      >
        <div className={brandRefreshStyles.imageRegion}>
          <img
            alt=""
            src={image}
            data-part="product-image"
            onError={i => {
              i.target.style.display = "none";
              return null;
            }}
            className={brandRefreshStyles.productImage}
          />
          <BrandRefreshBadges metaTags={metaTags} />
        </div>
        {description && (
          <div className={brandRefreshStyles.infoBtnWrapper}>
            <button
              type="button"
              className={brandRefreshStyles.infoBtn}
              aria-label="Show description"
              data-part="info-btn"
              onClick={isMobile ? toggleDescription : undefined}
              onMouseEnter={() => !isMobile && setShowTooltip(true)}
              onMouseLeave={() => !isMobile && setShowTooltip(false)}
            >
              <img src={infoIcon} alt="" aria-hidden="true" />
            </button>
            {!isMobile && showTooltip && <BrandRefreshTooltip description={description} />}
          </div>
        )}

        <div className={brandRefreshStyles.contentRegion}>
          <h3 className={brandRefreshStyles.productTitle} data-part="product-title">
            {name}
            {calories && (
              <span className={brandRefreshStyles.productDescription}> 
                {' '}
                {calories}
              </span>
            )}
          </h3>

          <div className={brandRefreshStyles.footer}>
            {renderBrandRefreshPrice(price, currency) || <span />}
            <BrandRefreshQuantityControl
              quantity={quantity}
              onChangeAdd={onChangeAdd}
              onChangeRemove={onChangeRemove}
              oos={oos}
              addDisabled={addDisabled}
            />
          </div>
        </div>
      </div>

      {isMobile && showDescription && description && (
        <BrandRefreshDescriptionModal
          title={name}
          description={description}
          onClose={() => setShowDescription(false)}
        />
      )}
    </>
  );
}

function CustomQuantityOption(props) {
  // Hooks must always be called unconditionally at the top level of the
  // component, regardless of which render path (legacy vs. brand refresh)
  // is ultimately used. The brand refresh path is opted into via
  // isBrandRefreshEnabled(); legacy path ignores this state entirely.
  const [showDescription, setShowDescription] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const isMobile = useIsMobile();

  if (isBrandRefreshEnabled()) {
    return renderBrandRefreshQuantityOption(props, {
      showDescription,
      setShowDescription,
      isMobile,
      showTooltip,
      setShowTooltip,
    });
  }
  return renderLegacyQuantityOption(props);
}

export default CustomQuantityOption;